import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ResidenceIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ResidenceIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.5001 21.9883H2.50011C2.22374 21.9883 2.00011 21.7646 2.00011 21.4883C2.00011 21.2119 2.22374 20.9883 2.50011 20.9883H21.5001C21.7765 20.9883 22.0001 21.2119 22.0001 21.4883C22.0001 21.7646 21.7765 21.9883 21.5001 21.9883Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.1246 21.9883H3.97472C3.69835 21.9883 3.47472 21.7646 3.47472 21.4883V8.40819C3.47472 8.13182 3.69835 7.90819 3.97472 7.90819H13.0465L16.3375 5.13182C16.5221 4.97459 16.7931 4.97459 16.9806 5.12987L20.4454 8.0244C20.5587 8.11913 20.6246 8.25975 20.6246 8.40819V21.4883C20.6246 21.7646 20.401 21.9883 20.1246 21.9883ZM4.47472 20.9883H19.6246V8.64159L16.6612 6.16698L13.5514 8.79003C13.4615 8.8662 13.3473 8.90819 13.2291 8.90819H4.47472V20.9883Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.5001 8.90819H20.1246C19.8482 8.90819 19.6246 8.68456 19.6246 8.40819C19.6246 8.13182 19.8482 7.90819 20.1246 7.90819H20.6896L18.2291 3.01171H5.77062L3.31066 7.90819H12.6456C12.922 7.90819 13.1456 8.13182 13.1456 8.40819C13.1456 8.68456 12.922 8.90819 12.6456 8.90819H2.50011C2.32677 8.90819 2.16564 8.81835 2.07433 8.67089C1.98351 8.52343 1.97521 8.33886 2.05333 8.18359L5.01524 2.28711C5.1002 2.11816 5.27305 2.01172 5.46202 2.01172H18.5377C18.7267 2.01172 18.8995 2.11817 18.9845 2.28711L21.9469 8.18359C22.0245 8.33886 22.0167 8.52343 21.9259 8.67089C21.8346 8.81835 21.6734 8.90819 21.5001 8.90819Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.9464 21.9883H14.9444C14.6681 21.9883 14.4444 21.7646 14.4444 21.4883V16.2353C14.4444 15.959 14.6681 15.7353 14.9444 15.7353H17.9464C18.2228 15.7353 18.4464 15.959 18.4464 16.2353V21.4883C18.4464 21.7646 18.2228 21.9883 17.9464 21.9883ZM15.4444 20.9883H17.4464V16.7353H15.4444V20.9883Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.5499 19.5586H6.40344C6.12707 19.5586 5.90344 19.335 5.90344 19.0586V16.2353C5.90344 15.959 6.12707 15.7353 6.40344 15.7353H12.5499C12.8263 15.7353 13.0499 15.959 13.0499 16.2353V19.0586C13.0499 19.335 12.8263 19.5586 12.5499 19.5586ZM6.90344 18.5586H12.0499V16.7353H6.90344V18.5586Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.55382 14.2334H6.40343C6.12706 14.2334 5.90343 14.0098 5.90343 13.7334V10.9101C5.90343 10.6338 6.12706 10.4101 6.40343 10.4101H8.55382C8.83019 10.4101 9.05382 10.6338 9.05382 10.9101V13.7334C9.05382 14.0098 8.83019 14.2334 8.55382 14.2334ZM6.90343 13.2334H8.05382V11.4101H6.90343V13.2334Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.5499 14.2334H10.3995C10.1232 14.2334 9.89953 14.0098 9.89953 13.7334V10.9101C9.89953 10.6338 10.1232 10.4101 10.3995 10.4101H12.5499C12.8263 10.4101 13.0499 10.6338 13.0499 10.9101V13.7334C13.0499 14.0098 12.8263 14.2334 12.5499 14.2334ZM10.8995 13.2334H12.0499V11.4101H10.8995V13.2334Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.9464 14.3408H14.9444C14.6681 14.3408 14.4444 14.1172 14.4444 13.8408V11.2568C14.4444 10.1533 15.3419 9.25585 16.4454 9.25585C17.5489 9.25585 18.4464 10.1533 18.4464 11.2568V13.8408C18.4464 14.1172 18.2228 14.3408 17.9464 14.3408ZM15.4444 13.3408H17.4464V11.2568C17.4464 10.7051 16.9972 10.2558 16.4454 10.2558C15.8937 10.2558 15.4444 10.7051 15.4444 11.2568L15.4444 13.3408Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ResidenceIcon;
